import { useContext, useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import api from "../../services/api";
import { finalizeLogin } from "./loginFinalize";
import GlobalContext from "../../contexts/GlobalContext";

const LoginHandoff = () => {
  const [message, setMessage] = useState("Validando acesso...");
  const context = useContext(GlobalContext);

  useEffect(() => {
    const runHandoff = async () => {
      const searchParams = new URLSearchParams(window.location.search);
      const ticket = searchParams.get("ticket");
      const pParam = searchParams.get("p");

      if (!ticket) {
        window.location.href = pParam ? `/login/?p=${pParam}` : "/login/";
        return;
      }

      // Em ambiente local com StrictMode, o componente pode montar 2x.
      // Esse lock evita consumir o mesmo ticket mais de uma vez no browser.
      const lockKey = `handoff_lock_${ticket}`;
      if (sessionStorage.getItem(lockKey) === "1") {
        return;
      }
      sessionStorage.setItem(lockKey, "1");

      try {
        const response = await api.post("/login/handoff/consume/", { ticket });

        finalizeLogin({
          responseApi: response.data,
          pParam,
          setGlobalValue: context?.setGlobalValue,
        });
      } catch (error) {
        sessionStorage.removeItem(lockKey);
        setMessage("Não foi possível concluir seu acesso. Redirecionando...");
        setTimeout(() => {
          window.location.href = pParam ? `/login/?p=${pParam}` : "/login/";
        }, 1000);
      }
    };

    runHandoff();
  }, []);

  return (
    <div className="login-page d-flex flex-column align-items-center justify-content-center">
      <Spinner animation="border" className="mb-3" />
      <p className="text-white">{message}</p>
    </div>
  );
};

export default LoginHandoff;
